(function () {
  const modal = document.getElementById('quickViewModal');
  if (!modal) return;

  const mainImg = document.getElementById('quickViewImage');
  const thumbsEl = document.getElementById('quickViewThumbs');
  const discountBadge = document.getElementById('quickViewDiscountBadge');
  const prevBtn = document.getElementById('quickViewPrev');
  const nextBtn = document.getElementById('quickViewNext');
  const counterEl = document.getElementById('quickViewCounter');
  const brandEl = document.getElementById('quickViewBrand');
  const titleEl = document.getElementById('quickViewTitle');
  const priceEl = document.getElementById('quickViewPrice');
  const compareEl = document.getElementById('quickViewCompare');
  const saveEl = document.getElementById('quickViewSave');
  const optionsEl = document.getElementById('quickViewOptions');
  const qtyInput = document.getElementById('quickViewQtyInput');
  const addBtn = document.getElementById('quickViewAddBtn');
  const addLabel = document.getElementById('quickViewAddLabel');
  const buyNowBtn = document.getElementById('quickViewBuyNow');
  const whatsappLink = document.getElementById('quickViewWhatsapp');
  const fullLink = document.getElementById('quickViewFullLink');
  const errorEl = document.getElementById('quickViewError');
  const detailsTable = document.getElementById('quickViewDetailsTable');
  const fullDescription = document.getElementById('quickViewFullDescription');
  const deliveryDateEl = document.getElementById('quickViewDeliveryDate');

  let currentProduct = null;
  let selected = [];
  let images = [];
  let imgIndex = 0;
  let preloadedUrls = new Set();

  function optionName(opt) {
    if (opt == null) return '';
    if (typeof opt === 'string') return opt;
    if (typeof opt === 'object') return opt.name || '';
    return String(opt);
  }

  function hasRealOptions(product) {
    if (!product || !Array.isArray(product.options) || !product.options.length) return false;
    const names = product.options.map(optionName);
    if (names.length === 1 && names[0] === 'Title') return false;
    return true;
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    return 'Rs.' + (cents / 100).toLocaleString('en-PK');
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, function (_, ext, query) {
      return '_' + width + 'x' + ext + (query || '');
    });
  }

  function absUrl(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function findVariant() {
    if (!currentProduct || !currentProduct.variants) return null;
    return currentProduct.variants.find(v =>
      v.options.every((opt, i) => !selected[i] || opt === selected[i])
    ) || currentProduct.variants[0];
  }

  /* ── Gallery ── */
  function preloadImage(i) {
    if (!images.length) return;
    const idx = (i + images.length) % images.length;
    const src = sizedImage(images[idx], 900);
    if (!src || preloadedUrls.has(src)) return;
    const im = new Image();
    im.src = src;
    preloadedUrls.add(src);
  }

  function warmNeighbours() {
    // Warm a 2-image radius around the current one so next/prev almost
    // always hits the browser cache instead of a fresh network request.
    preloadImage(imgIndex + 1); preloadImage(imgIndex - 1);
    preloadImage(imgIndex + 2); preloadImage(imgIndex - 2);
  }

  function renderGallery() {
    thumbsEl.innerHTML = '';
    images = ((currentProduct && currentProduct.images) || []).map(absUrl);
    imgIndex = 0;
    preloadedUrls = new Set();

    if (!images.length) { prevBtn.hidden = nextBtn.hidden = true; counterEl.textContent = ''; return; }

    setImage(0);

    const showNav = images.length > 1;
    prevBtn.hidden = !showNav;
    nextBtn.hidden = !showNav;

    images.slice(0, 8).forEach((src, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'qv-thumb' + (i === 0 ? ' active' : '');
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      const t = document.createElement('img');
      t.src = sizedImage(src, 150);
      t.loading = 'lazy';
      btn.appendChild(t);
      btn.addEventListener('click', () => setImage(i));
      thumbsEl.appendChild(btn);
    });

    // Start warming neighbours as soon as the browser has a spare moment —
    // don't wait for the shopper to click next/prev first.
    (window.requestIdleCallback || window.requestAnimationFrame)(warmNeighbours);
  }

  function setImage(i) {
    imgIndex = (i + images.length) % images.length;
    const src = sizedImage(images[imgIndex], 900);
    mainImg.classList.add('is-loading');
    mainImg.src = src;
    if (mainImg.complete) mainImg.classList.remove('is-loading');
    else mainImg.addEventListener('load', () => mainImg.classList.remove('is-loading'), { once: true });
    counterEl.textContent = images.length > 1 ? (imgIndex + 1) + ' / ' + images.length : '';
    thumbsEl.querySelectorAll('.qv-thumb').forEach((t, idx) => t.classList.toggle('active', idx === imgIndex));
    warmNeighbours();
  }

  prevBtn.addEventListener('click', () => setImage(imgIndex - 1));
  nextBtn.addEventListener('click', () => setImage(imgIndex + 1));

  /* ── Options (Size / Color) ── */
  function renderOptions() {
    optionsEl.innerHTML = '';
    if (!hasRealOptions(currentProduct)) return;

    currentProduct.options.forEach((rawOption, position) => {
      const name = optionName(rawOption);
      const values = [...new Set((currentProduct.variants || []).map(v => v.options[position]).filter(Boolean))];
      if (!values.length) return;

      const group = document.createElement('div');
      group.className = 'variant-group';
      const lower = name.toLowerCase();
      const isColor = lower.includes('color') || lower.includes('colour');

      const label = document.createElement('label');
      label.className = 'selector-label';
      label.innerHTML = '<span>' + name + ': <span class="selected-value">' + (selected[position] || '') + '</span></span>';
      group.appendChild(label);

      const optGroup = document.createElement('div');
      optGroup.className = (isColor ? 'color-options' : 'size-options') + ' opt-group';
      optGroup.setAttribute('role', 'group');

      values.forEach(value => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = (isColor ? 'color-swatch' : 'size-btn') + ' opt-btn' + (selected[position] === value ? ' active' : '');
        btn.dataset.position = position;
        btn.dataset.value = value;
        if (isColor) {
          btn.style.setProperty('--swatch', String(value).toLowerCase());
          btn.innerHTML = '<span class="color-swatch-inner"></span>';
          btn.setAttribute('aria-label', value);
        } else {
          btn.textContent = value;
        }
        btn.addEventListener('click', () => {
          selected[position] = value;
          renderOptions();
          updateSelectedVariant();
        });
        optGroup.appendChild(btn);
      });

      group.appendChild(optGroup);
      optionsEl.appendChild(group);
    });
  }

  function updateSelectedVariant() {
    const variant = findVariant();
    if (!variant) {
      addBtn.disabled = true;
      addLabel.textContent = 'Select options';
      return;
    }
    priceEl.textContent = money(variant.price);
    if (variant.compare_at_price > variant.price) {
      compareEl.textContent = money(variant.compare_at_price);
      compareEl.hidden = false;
      saveEl.textContent = 'Save ' + money(variant.compare_at_price - variant.price);
      saveEl.hidden = false;
      const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      discountBadge.textContent = '-' + pct + '%';
      discountBadge.hidden = false;
    } else {
      compareEl.hidden = true;
      saveEl.hidden = true;
      discountBadge.hidden = true;
    }
    const available = variant.available;
    addBtn.disabled = !available;
    addLabel.textContent = available ? 'Add to Bag' : 'Sold Out';
    addBtn.dataset.variantId = variant.id;
    buyNowBtn.disabled = !available;
  }

  /* ── Details section (below the fold) ── */
  function renderDetails(product) {
    detailsTable.innerHTML = '';
    const rows = [];
    if (product.vendor) rows.push(['Brand', product.vendor]);
    const variant = findVariant();
    if (variant && variant.options && Array.isArray(product.options)) {
      product.options.forEach((rawOption, i) => {
        const name = optionName(rawOption);
        if (name && name !== 'Title' && variant.options[i]) rows.push([name, variant.options[i]]);
      });
    }
    rows.forEach(([k, v]) => {
      const tr = document.createElement('tr');
      tr.innerHTML = '<th>' + k + '</th><td>' + v + '</td>';
      detailsTable.appendChild(tr);
    });

    fullDescription.innerHTML = product.description || '';
  }

  /* ── Open / close ── */
  function open() {
    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add('open'));
    document.body.style.overflow = 'hidden';
  }

  function close() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => { modal.hidden = true; }, 220);
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  async function loadProduct(url, title) {
    brandEl.textContent = '';
    titleEl.textContent = title || '';
    priceEl.textContent = '';
    compareEl.hidden = true;
    saveEl.hidden = true;
    discountBadge.hidden = true;
    optionsEl.innerHTML = '';
    thumbsEl.innerHTML = '';
    mainImg.src = '';
    counterEl.textContent = '';
    errorEl.hidden = true;
    detailsTable.innerHTML = '';
    fullDescription.innerHTML = '';
    addBtn.disabled = true;
    addLabel.textContent = 'Loading…';
    fullLink.href = url;
    open();

    try {
      const fmt = d => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      const from = new Date(); from.setDate(from.getDate() + 3);
      const to = new Date(); to.setDate(to.getDate() + 5);
      deliveryDateEl.textContent = fmt(from) + ' – ' + fmt(to);
    } catch (e) {}

    let product;
    try {
      const res = await fetch(url + '.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      product = await res.json();
    } catch (err) {
      showError("Couldn't load full details — use \u2018View full details\u2019 below.");
      addLabel.textContent = 'View product page';
      addBtn.disabled = true;
      return;
    }

    currentProduct = product;

    try { brandEl.textContent = product.vendor || ''; } catch (e) {}
    try { titleEl.textContent = product.title || title || ''; } catch (e) {}
    try { renderGallery(); } catch (e) {}
    try {
      const firstAvailable = (product.variants || []).find(v => v.available) || (product.variants && product.variants[0]);
      selected = firstAvailable ? [...firstAvailable.options] : [];
    } catch (e) { selected = []; }
    try { renderOptions(); } catch (e) {}
    try { updateSelectedVariant(); } catch (e) {
      addLabel.textContent = 'View product page';
      addBtn.disabled = true;
    }
    try { renderDetails(product); } catch (e) {}
    try {
      whatsappLink.href = 'https://wa.me/923134469687?text=' + encodeURIComponent('Hi! I\'m interested in ' + (product.title || '') + ' (' + window.location.origin + url + ')');
    } catch (e) {}
  }

  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    loadProduct(trigger.dataset.productUrl, trigger.dataset.productTitle);
  });

  document.getElementById('quickViewClose').addEventListener('click', close);
  modal.addEventListener('click', e => { if (e.target === modal) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) close(); });

  document.getElementById('quickViewQtyDown').addEventListener('click', () => {
    if (+qtyInput.value > 1) qtyInput.value = +qtyInput.value - 1;
  });
  document.getElementById('quickViewQtyUp').addEventListener('click', () => {
    if (+qtyInput.value < 10) qtyInput.value = +qtyInput.value + 1;
  });

  async function addToCart(redirectAfter) {
    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;
    addLabel.textContent = 'Adding…';
    addBtn.disabled = true;
    buyNowBtn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: +qtyInput.value })
      });
      if (res.ok) {
        if (redirectAfter) { window.location.href = '/checkout'; return; }
        addLabel.textContent = 'Added ✓';
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const countEl = document.getElementById('cartCount');
          if (countEl) {
            countEl.textContent = cart.item_count;
            countEl.style.display = cart.item_count > 0 ? '' : 'none';
          }
        } catch (e) {}
        if (typeof window.tarzToast === 'function') window.tarzToast('Added to bag');
        setTimeout(close, 700);
      } else {
        addLabel.textContent = 'Could not add — try again';
        addBtn.disabled = false;
        buyNowBtn.disabled = false;
      }
    } catch (err) {
      addLabel.textContent = 'Could not add — try again';
      addBtn.disabled = false;
      buyNowBtn.disabled = false;
    }
  }

  addBtn.addEventListener('click', () => addToCart(false));
  buyNowBtn.addEventListener('click', () => addToCart(true));
})();
